<template>
  <button
    class="tw-p-3 tw-cursor-pointer tw-bg-white tw-shadow-sm tw-rounded-lg tw-text-[#F1583D] tw-flex tw-items-center tw-font-medium tw-whitespace-nowrap tw-border tw-border-solid tw-border-[#DFE2E7]"
    @click="$emit('click')"
  >
    <i class="fas fa-plus tw-mr-2" />
    Manually Create
  </button>
</template>

<script>
export default {
  name: 'CreateBenchmarkButton',
};
</script>
